import { styled } from '@mui/joy';

export const BodyWrapper = styled('div')`
  min-height: 100vh;
  min-width: fit-content;
`;
